// The response an account the admin switched off gets from every signed-in
// request (DEV-212; ApplicationController#render_switched_off). It is a 503
// with exactly this body -- deliberately not a 401, which would clear the token
// and show sign-in, and deliberately saying nothing about the account, so it
// reads as an outage. Keep GENERIC_ERROR in step with the Rails constant of
// the same name.
//
// Both halves are checked: a bare 503 also comes from a server with no API key
// configured, and that is a real outage, not this.
export const GENERIC_ERROR = "Something went wrong";

export function isSwitchedOff(error) {
  const response = error?.response;
  return response?.status === 503 && response?.data?.error === GENERIC_ERROR;
}
